import { Sample } from 'types/generated/graphql';

export const isSample = (item: unknown): item is Sample => {
    return (item as Sample).__typename === 'Sample';
};
